module.exports = __webpack_public_path__ + "media/native-apps/vastervikoutdoor-4fe38de1.webp";